import React from 'react';
import { motion } from 'framer-motion';
import { generatePlanPDF } from '../utils/generatePlanPDF';
const questions = ['¿Quieres desinflamar por abdomen, retención de líquidos, gastritis/colon irritable, o dolor articular?', '¿Tienes alguna condición (diabetes, hígado graso, gastritis, hipertensión) o tomas medicamentos?', '¿Qué no comes (lácteos, gluten, carne, etc.)?', '¿Cuántos kilos/peso/altura y nivel de actividad tienes?'];
export function PersonalizeSection() {
  return <section id="pricing" className="py-24 px-4 sm:px-6 lg:px-8 relative overflow-hidden" data-id="element-112">
      {/* Warm orange gradient background */}
      <div className="absolute inset-0 bg-gradient-to-br from-orange-50 via-wellness-cream to-orange-100/50 -z-10" data-id="element-113" />

      <div className="max-w-5xl mx-auto" data-id="element-114">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-white/60 backdrop-blur-xl rounded-[3rem] p-8 sm:p-12 lg:p-16 shadow-organic border border-white/80 text-center" data-id="element-115">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-wellness-accent/10 text-wellness-accent mb-8" data-id="element-116">
            <div className="w-10 h-10" data-id="element-117" />
          </div>

          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-wellness-primary" data-id="element-118">
            ¿Quieres un plan a tu medida?
          </h2>

          <p className="text-xl text-wellness-text/80 max-w-2xl mx-auto mb-12" data-id="element-119">
            Para adaptar este plan exactamente a tu objetivo y necesidades,
            responde estas 4 preguntas clave:
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-left" data-id="element-120">
            {questions.map((q, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2 + index * 0.1
          }} className="bg-white rounded-2xl p-6 shadow-sm border border-orange-100/50 flex gap-4" data-id="element-121">
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-wellness-accent text-white flex items-center justify-center font-bold font-serif" data-id="element-122">
                  {index + 1}
                </div>
                <p className="text-wellness-text/90 text-lg leading-relaxed pt-1" data-id="element-123">
                  {q}
                </p>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.8
        }} className="mt-12 flex flex-col items-center gap-4" data-id="element-124">
            <div className="flex items-baseline gap-3 mb-2" data-id="element-125">
              <span className="text-wellness-text/40 line-through text-xl" data-id="element-126">
                $14.99
              </span>
              <span className="text-5xl font-bold text-wellness-primary" data-id="element-127">
                $7.18
              </span>
            </div>
            <p className="text-sm text-wellness-text/60 mb-2" data-id="element-128">
              Precio especial por tiempo limitado · Plan completo de 14 días
            </p>
            <button onClick={() => generatePlanPDF()} className="px-10 py-5 bg-wellness-accent text-white rounded-2xl font-semibold text-xl shadow-lg shadow-orange-500/20 hover:bg-orange-600 transition-colors" data-id="element-129">
              📥 Descargar Mi Plan en PDF
            </button>
            <p className="text-xs text-wellness-text/50 mt-1" data-id="element-130">
              Acceso inmediato · Sin suscripción · Pago único
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}